import GeneralStatus from '@/models/Shared/GeneralStatus';

export default class CreateCompanyRequest  {
	status: GeneralStatus = GeneralStatus.ActiveOrApproved;
    brandName = "";  
    registeredName = "";
    emailAddress = "";
    phoneNumber = "";
}

